<template>
  <div class="container">
    <nav class="navbar navbar-fixed-top" role="navigation">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#top-navbar-1"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand" to="/">EMAP</router-link>
        </div>
      </div>
    </nav>
    <div class="row">
      <br />
      <br />
      <br />
      <br />
      <br />
      <div v-if="erro">
        <div class="alert alert-danger">
          <span
            ><i class="fa fa-exclamation fa-fw"></i>
            Erro ao tentar realizar login. Verifique seu usuário e senha.
          </span>
        </div>
      </div>
      <div class="col-md-4 col-md-offset-4">
        <div class="login-panel panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Entre no sistema</h3>
          </div>
          <div class="panel-body">
            <form role="form" @submit.prevent.stop="login">
              <fieldset>
                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder="E-mail"
                    name="email"
                    type="email"
                    autofocus
                    v-model="email"
                  />
                  <p v-if="!validarEmail && email !==''" style="color: red;">
                    <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                  </p>
                </div>
                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder="Password"
                    name="password"
                    type="password"
                    value=""
                    v-model="senha"
                  />
                </div>
                <!-- Change this to a button or input when using this as a form -->
                <button type="submit" class="btn btn-lg btn-info btn-block">
                  Login
                </button>
              </fieldset>
            </form>
            <br />
            <router-link
              class="btn btn-lg btn-warning btn-block"
              to="/recover-pass"
            >
              Recuperar Senha
            </router-link>
          </div>
        </div>
      </div>
      <div class="container">
        <!-- Main component for a primary marketing message or call to action -->
        <div class="col-md-4 col-md-offset-4">
          <p class="text-center">
            EMAP. Empresa Maranhense de Administração Portuária.
          </p>
          <p class="text-center"><b>versão {{config.version}} de {{config.versionDate}}</b>. Todos os direitos reservados 2021</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storage from "@/mixins/storage.js";
import config from "@/mixins/config.js"

export default {
  name: "Login",
  inject: ["loading"],
  data() {
    return {
      config:config,
      erro: false,
      email: "",
      senha: "",
    };
  },
  computed:{
    validarEmail() {
      const re = /\S+@\S+\.\S+/
      return re.test(this.email)
    }
  },
  methods: {
    login() {
      this.loading.value = true
      this.$http
        .post("/auth", { email: this.email, senha: this.senha })
        .then((response) => {
          const token = response.data.token;
          this.$http.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${token}`;
          storage.methods.setToken(token);

          this.$http
            .get(`/auth/info/${token}`)
            .then((response) => {
              storage.methods.setUser(response.data);
            })
            .catch((error) => console.log(error));

          this.$router.push("/admin");
          setTimeout(()=> this.loading.value = false, 1000)
        })
        .catch((error) => {
          this.erro = true;
          setTimeout(()=> this.loading.value = false, 1000)
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  margin-bottom: 0;
  background: #333;
  background: rgba(51, 51, 51, 0.8);
  border: 0;
  -moz-border-radius: 0;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.navbar-brand {
  width: 125px;
  height: 66px;
  text-indent: -99999px;
  background: url(../../assets/img/logo.png) left center no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue